

























































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";

import Customer, { customerInitValue } from "@/types/customer/Customer";
import CustomerService from "@/services/customerService";
import Header from "@/types/app/header";
import Endpoint from "@/utils/endpoint";
import BaseComponent from "@/utils/baseComponent";
import { ImportCompanyHeader, ImportInvestorHeader, ImportAccountHeader } from "@/components/headers/header-import-company";
import CompanyService from "@/services/companyService";
import InvestorInterface from "@/types/app/investor";
import router from "@/router";
import LesteManagerService from "@/services/lesteManagerService";
import LesteManagerItem from "@/types/app/lesteManagerItem";
import applyCondition from "@/utils/applyCondition";
import ManagerHeader from "@/components/headers/managers-header";
import LesteManagerItemHeader from "@/components/headers/lesteManagerItem-header";
import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import { Watch } from "vue-property-decorator";


@Component({
    components: {},
    data: () => ({
        isLCM: false,
        endpoint: new Endpoint(),
    }),
})
export default class LesteManagerDetail extends BaseComponent {
    @Getter("getCustomersAll", { namespace: "customer" }) customersAll!: Customer[];
    height = "";
    customer: Customer = customerInitValue;
    headers: Header[] = LesteManagerItemHeader.header;
    errorCreate = false;
    loading = false;
    lesteManagerService = new LesteManagerService(this.$http)
    customerService = new CustomerService(this.$http);
    companyService = new CompanyService(this.$http);
    lesteManagerItems: LesteManagerItem[] = [];
    customers: InvestorInterface[] = [];
    errorMessage = "";
    validationMessage = "";
    itemNameFilter = "";
    valid = false;
    customersOthers: VuetifySelectItems[] = [];
    selectedCustomers: VuetifySelectItems[] = [];
    companiesOthers: VuetifySelectItems[] = [];
    selectedCompanies: VuetifySelectItems[] = [];
    loadingClients = false;
    dialog = false;
    dialogDelete = false;
    isClientUser = true;
    editedIndex = -1;
    edited!: LesteManagerItem;

    async mounted() {
        this.loading = true;
        try {
            const [customerResponse, _] = await Promise.all([
                this.lesteManagerService.getSelectLesteManagerItems(this.customerId),
                this.loadCustomer()
            ]);
            this.lesteManagerItems = customerResponse || [];
        } catch (error) {
            console.log('Error mounted', error);
        } finally {
            this.loading = false;
        }
    }

    get customerId(): string {
        return this.$route.params.customerId
    }

    get likesAllCustomer() {
        return this.selectedCustomers.length === this.customersOthers.length;
    }

    get likesSomeCustomers() {
        return this.selectedCustomers.length > 0 && !this.likesAllCustomer;
    }
    get icon() {
        if (this.likesAllCustomer) return "mdi-close-box";
        if (this.likesSomeCustomers) return "mdi-minus-box";
        return "mdi-checkbox-blank-outline";
    }


    toggleSelectAll() {
        this.$nextTick(() => {
            if (this.likesAllCustomer) {
                this.selectedCustomers = [];
            } else {
                this.selectedCustomers = this.customersOthers;
            }
        });
    }


    get likesAllCompany() {
        return this.selectedCompanies.length === this.companiesOthers.length;
    }

    get likesSomeCompanies() {
        return this.selectedCompanies.length > 0 && !this.likesAllCompany;
    }
    get iconCompany() {
        if (this.likesAllCompany) return "mdi-close-box";
        if (this.likesSomeCompanies) return "mdi-minus-box";
        return "mdi-checkbox-blank-outline";
    }


    toggleSelectCompanyAll() {
        this.$nextTick(() => {
            if (this.likesAllCompany) {
                this.selectedCompanies = [];
            } else {
                this.selectedCompanies = this.companiesOthers;
            }
        });
    }


    @Watch("isClientUser")
    toggleIsClientUser() {
        this.selectedCompanies = [];
        this.selectedCustomers = [];
    }

    @Watch("dialog")
    async getCustomers(): Promise<void> {
        this.loadingClients = true;

        const [taskCustomer, taskCompany] = await Promise.all([
            this.customerService.getSelectManagerCustomers(),
            this.companyService.getCompanyItems()]);
        this.customersOthers = taskCustomer;
        this.companiesOthers = taskCompany;
        this.loadingClients = false;
    }


    get filtered() {
        const conditions: any[] = [];
        if (this.itemNameFilter) {
            conditions.push((item: LesteManagerItem) =>
                item.name?.toLowerCase().includes(this.itemNameFilter.toLowerCase())
            );
        }
        return applyCondition<LesteManagerItem>(this.lesteManagerItems, conditions);
    }

    async loadCustomer() {
        this.customer = await this.customerService.getCustomerById(this.customerId);
    }

    clear() {
        this.errorMessage = "";
        this.validationMessage = "";
        this.errorCreate = false;
    }

    closeModal(): void {
        //this.setModalImportInterestState(false);
        this.clear();

        router.push({
            name: "LesteManagers"
        });
    }

    closeManagerModal() {
        if (this.selectedCustomers.length > 0 || this.selectedCompanies.length > 0) {
            this.$confirm("Are you sure you want to exit without saving?").then((res) => {
                if (res) {
                    this.dialog = false;
                    this.$nextTick(() => {
                        this.selectedCustomers = [];
                        this.isClientUser = true;
                    });
                }
            });
        }
        else {
            this.dialog = false;
            this.$nextTick(() => {
                this.selectedCustomers = [];
                this.isClientUser = true;
            })
        }

    }

    async addManagerModal() {
        if (!this.form().validate()) {
            return false;
        }
        this.loadingClients = true;
        try {
            let clients: LesteManagerItem[] = [];

            if (this.isClientUser)
                clients = this.selectedCustomers.map(x =>
                    ({ email: x.email, id: x.value, name: x.name, isClientUser: true }) as LesteManagerItem
                )
            else
                clients = this.selectedCompanies.map(x =>
                    ({ email: x.email, id: x.value, name: x.name, isClientUser: true }) as LesteManagerItem
                )
            const result = await this.lesteManagerService.saveItems(this.customerId, this.isClientUser, clients);
            clients.forEach(element => {
                this.lesteManagerItems.push(element as LesteManagerItem);
            });
            if (result) {
                this.showSuccess('Select some members to Leste Manager with successfully');
                this.selectedCompanies = [];
                this.selectedCustomers = [];
                this.closeManagerModal();
            }
            else {
                this.showError('Cannot save select members');
            }

        } finally {
            this.loadingClients = false;
        }

    }

    closeDelete() {
        this.dialogDelete = false
        this.$nextTick(() => {
            this.editedIndex = -1
        })
    }

    deleteConfirm() {
        this.loadingClients = true;
        try {
            this.lesteManagerService.deleteItems(this.customerId, this.isClientUser, this.edited.id);
            this.lesteManagerItems.splice(this.editedIndex, 1);
            this.closeDelete()
        }
        finally {
            this.loadingClients = false;
        }
    }

    deleteClick(item: LesteManagerItem) {
        this.editedIndex = this.lesteManagerItems.indexOf(item)
        this.edited = Object.assign({}, item)
        this.dialogDelete = true
    }
}
